<template>
  <div class="fullview" @click.self="okAction">
    <div class="dialog-card">
      <button class="close-btn" @click="okAction" aria-label="閉じる">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4L16 16M16 4L4 16" stroke="#8C9BC6" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>

      <p class="dialog-title">
        契約者様は「ACRY APP」からも<br />
        ご注文いただけます
      </p>

      <div class="subtitle-pill">
        ACRY APP最新版でPRO注文に対応
      </div>

      <div class="mx-auto" style="height: 8px; width: 86%; background: #EEECF1; margin-top: -8px;">
      </div>

      <div class="preview-image-wrap">
        <img :src="proInfoImage" class="preview-image" alt="ACRY APP プレビュー" />
      </div>

      <button class="btn-primary" @click="launchAcryAppAction">
        ACRY APPを起動
      </button>

      <!-- <button class="btn-outline" @click="openAppStoreAction">
        アプリをダウンロード
      </button> -->

      <div class="copy-link" @click="copyAcryProLinkAction">
        <span class="copy-link-text">
          PCで利用する場合は<br />
          <span class="copy-link-url">ACRY PROのURLをコピー</span>
        </span>
        <span class="copy-link-icon">
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="4" y="4" width="9" height="10" rx="1.5" stroke="#8C9BC6" stroke-width="1.4"/>
            <path d="M3 11V3.5C3 2.67157 3.67157 2 4.5 2H11" stroke="#8C9BC6" stroke-width="1.4" stroke-linecap="round"/>
          </svg>
        </span>
      </div>

      <!-- <p v-if="isCopied" class="copied-toast">コピーしました</p> -->
    </div>
  </div>
</template>

<script>
import proInfoImage from "@/assets/acrypro/pro_info.png";

const ACRY_APP_LAUNCH_URL = "https://d1oar49h4ajbdt.cloudfront.net";
const ACRY_APP_STORE_URL = "https://apps.apple.com/jp/app/acry/id1234567890";

export default {
  name: "PcAccessDialog",
  data() {
    return {
      proInfoImage,
      isCopied: false,
    };
  },
  computed: {
    acryProUrl() {
      if (typeof window === "undefined") return "";
      return window.location.origin + "/";
    },
  },
  methods: {
    async okAction() {
      const callback = this.$store.state.pcAccessDialogCallback;
      this.$store.commit("hidePcAccessDialog");
      if (callback) {
        await callback();
      }
    },
    async copyAcryProLinkAction() {
      const url = this.acryProUrl;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = url;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.isCopied = true;
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
      } catch (e) {
        this.isCopied = false;
      }
    },
    launchAcryAppAction() {
      window.location.href = ACRY_APP_LAUNCH_URL;
    },
    openAppStoreAction() {
      window.open(ACRY_APP_STORE_URL, "_blank");
    },
  },
};
</script>

<style scoped>
.fullview {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 50000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.dialog-card {
  position: relative;
  width: 100%;
  max-width: 340px;
  background-color: #FFFFFF;
  border-radius: 16px;
  padding: 40px 24px 24px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  text-align: center;
  font-family: 'Noto Sans JP', sans-serif;
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.close-btn:hover {
  opacity: 0.7;
}

.dialog-title {
  font-size: 17px;
  font-weight: 700;
  color: #8C9BC6;
}

.subtitle-pill {
  color: #595959;
  font-size: 15px;
  letter-spacing: 0.75px;
}

.preview-image-wrap {
  margin-top: 10px;
  margin-bottom: 24px;
}

.preview-image {
  width: 100%;
  max-width: 280px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.btn-primary,
.btn-outline {
  display: block;
  width: 100%;
  max-width: 280px;
  height: 48px;
  margin: 0 auto 12px;
  border-radius: 999px;
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.15s;
}

.btn-primary {
  border-radius: 100px;
  font-size: 16px;
  background-color: #8C9BC6;
  color: #FFFFFF;
  border: 2px solid #8C9BC6;
}
.btn-primary:hover {
  opacity: 0.85;
}

.btn-outline {
  border-radius: 100px;
  font-size: 16px;
  background-color: #FFFFFF;
  color: #8C9BC6;
  border: 2px solid #8C9BC6;
}
.btn-outline:hover {
  opacity: 0.85;
}

.copy-link {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  color: #595959;
  font-size: 12px;
  line-height: 1.6;
}
.copy-link:hover {
  opacity: 0.7;
}

.copy-link-text {
  text-align: center;
  color: #8C9BC6;
}

.copy-link-url {
  color: #8C9BC6;
  text-decoration: underline;
}

.copy-link-icon {
  display: inline-flex;
  align-items: flex-end;
  margin-top: 20px;
  margin-left: -2px;
}

.copied-toast {
  margin: 8px 0 0;
  font-size: 12px;
  color: #4CAF50;
}
</style>
